///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.classroom-teaching-tool-select-js')) {
      const classroomSelect = document.querySelector('.classroom-select-js');

      classroomSelect.addEventListener('change', autoSelectTeachingTool);
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Auto-select matched teaching tool
  //               according to classroom selection
  //
  function autoSelectTeachingTool(e) {
    const teachingToolSelector = document.querySelector('.classroom-teaching-tool-select-js'),
          autoSelectedTeachingTools = teachingToolSelector.dataset.autoSelectedTeachingTools,
      //  JSON.parse hash in data attr
          parsedTeachingTools = JSON.parse(autoSelectedTeachingTools),
          target = e.target,
          classroomSelection = target.value,
          teachingToolSelect = document.querySelector('.teaching-tool-auto-select-js'),
      //  access hash at selected value
          matchedTeachingTools = parsedTeachingTools[classroomSelection];

    // set first matched teaching tool id as value in teaching tool dropdown
    teachingToolSelect.value = matchedTeachingTools.teaching_tool_ids[0];

    setAutoSelectMessage(matchedTeachingTools.message);
  }

  ///////////////////////////////////////////////
  //
  // Description - Displays alert element and sets
  //               auto-select message
  //
  function setAutoSelectMessage(message) {
    const autoSelectMessage = document.querySelector('.auto-select-message-js');

    // display alert and render message under teaching tool dropdown
    if (autoSelectMessage.classList.contains('d-none')) {
      autoSelectMessage.classList.remove('d-none');
    }

    autoSelectMessage.innerText = message;
  }
}());
